/**
 * Module dependencies.
 */

import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from 'src/components/core/button';
import { StickyLayoutRightActionPortal } from 'src/components/layout/sticky';
import { handleKeyboardEventProps } from 'src/core/utils/links';
import { useBreakpoint } from 'src/hooks/use-breakpoints';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  hiddenVisually: boolean;
  onClick: () => void;
  submitLabel?: string;
} & ButtonProps;

/**
 * `NoContent` constant.
 */

const NoContent = () => null;

/**
 * `ActionsWrapper` styled component.
 */

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/**
 * `SubmitButton` component.
 */

export function SubmitButton(props: Props) {
  const { hiddenVisually, onClick, submitLabel, ...rest } = props;
  const { t } = useTranslation();
  const isMobile = useBreakpoint(0, 'md');
  const ActionComponent = isMobile ? NoContent : StickyLayoutRightActionPortal;
  const buttonProps = {
    ...rest,
    ...(handleKeyboardEventProps(onClick) as any),
    children: submitLabel ?? t('common:actions.save'),
    onClick,
    size: !isMobile ? 'small' : undefined,
    stretch: isMobile,
    style: hiddenVisually ? { opacity: 0, pointerEvents: 'none' } : undefined
  };

  return (
    <>
      <ActionComponent>
        <Button {...buttonProps} stretch={isMobile} />
      </ActionComponent>

      <ActionsWrapper>
        <Button {...buttonProps} />
      </ActionsWrapper>
    </>
  );
}
